/**
 * Fullscreen é best-effort: se o navegador recusar (sem gesto do usuário, dentro
 * de iframe), o overlay já ocupa a viewport inteira e a apresentação segue.
 */
export async function entrarFullscreen(el: HTMLElement | null): Promise<void> {
  if (!el?.requestFullscreen) return
  try {
    await el.requestFullscreen()
  } catch {
    // Recusado pelo navegador — mantém o overlay em tela cheia mesmo assim.
  }
}

export async function sairFullscreen(): Promise<void> {
  if (!document.fullscreenElement || !document.exitFullscreen) return
  try {
    await document.exitFullscreen()
  } catch {
    // Já não havia fullscreen ativo.
  }
}
